import subCategory from '../sub-category/index.vue'
export default {
  props:['category'],
  name: "categories",
  components:{
    subCategory
  }
}